export default "__VITE_ASSET__B8ZvVP67__"